import axios from "axios";
import { getHomeLinksByCountry } from "./GetHomeLinksByCountryAction";
import {
  updateHomeLinkRequested,
  updateHomeLinkRequestSucceeded,
  updateHomeLinkRequestFailed,
} from "../slices/UpdateHomeLinkSlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Home/UpdateHomeLink`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

export const UpdateHomeLink = (homeLink) => async (dispatch) => {
  try {
    dispatch(updateHomeLinkRequested());

    const putData = {
      idhomeLink: Number(homeLink.idhomeLink),
      name: homeLink.name,
      url: homeLink.url,
      imagePath: homeLink.imagePath,
      countryId: Number(homeLink.countryId ?? getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(apiUrl, putData, axiosConfig);

    if (response.data === true) {
      dispatch(updateHomeLinkRequestSucceeded(response.data));
      await dispatch(getHomeLinksByCountry());
      return { success: true, message: "Home link updated successfully" };
    }

    const errorMessage =
      "The home link could not be updated. A link with the same name may already exist for this country.";
    dispatch(updateHomeLinkRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(updateHomeLinkRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
